import React, { useState } from 'react'
import {
    MotifFormField,
    MotifLabel,
    MotifInput,
} from "@ey-xd/motif-react";
import { MotifErrorMessage } from '@ey-xd/motif-react';
import { avoidXSSattack } from 'utils/security';
import { MAX_INPUT_LENGTH } from 'components/Clients/constants';

const Input = ({ label, onChange, isError, errorMsg, maxLength = MAX_INPUT_LENGTH, ...props}: any) => {

    const [value, setValue] = useState('')

    const handleOnChange = (e: any) => {
        e=avoidXSSattack(e)
        setValue(e.target.value)
        onChange && onChange(e)
    }
    return (
        <MotifFormField>
            <MotifLabel>{label}</MotifLabel>
            <MotifInput value={value} onChange={handleOnChange} {...props} maxLength={maxLength}/>
            {isError ? <MotifErrorMessage role='alert'> {errorMsg} </MotifErrorMessage> : null}
        </MotifFormField>
    )
}

export default Input